import { createSelector } from 'reselect'

import { getTypeKey } from '../utils/message';

const sortMessages = messages => messages.sort((m1, m2) => new Date(m2.created_at) - new Date(m1.created_at));

const getMessage = (messages, messageId) => messages.find(message => message.id === messageId);
export const makeGetMessage = () => createSelector(getMessage, message => message);

const getMessagesByTypeAndAssociationId = (messages, type, associationId, excludeRemoved) => sortMessages(messages.filter(message => message[getTypeKey(type)] === associationId && (!excludeRemoved || !message.is_deleted)));
export const makeGetMessagesByTypeAndAssociationId = () => createSelector(getMessagesByTypeAndAssociationId, messages => messages);

const getSystemMessagesByTypeAndAssociationId = (messages, type, associationId) => sortMessages(messages.filter(message => message.subtype && message[getTypeKey(type)] === associationId));
export const makeGetSystemMessagesByTypeAndAssociationId = () => createSelector(getSystemMessagesByTypeAndAssociationId, messages => messages);

const getNonSystemMessagesByTypeAndAssociationId = (messages, type, associationId, excludeRemoved) => sortMessages(messages.filter(message => !message.subtype && message[getTypeKey(type)] === associationId && (!excludeRemoved || !message.is_deleted)));
export const makeGetNonSystemMessagesByTypeAndAssociationId = () => createSelector(getNonSystemMessagesByTypeAndAssociationId, messages => messages);

const getEarliestMessagesByTypeAndAssociationId = (messages, type, associationId, excludeRemoved) => {
    const result = sortMessages(messages.filter(message => message[getTypeKey(type)] === associationId && (!excludeRemoved || !message.is_deleted)));
    return result[result.length - 1];
};
export const makeGetEarliestMessagesByTypeAndAssociationId = () => createSelector(getEarliestMessagesByTypeAndAssociationId, messages => messages);

const getLastSelfMessage = (messages, type, associationId, currentUserId) => {
    const result = sortMessages(messages.filter(message =>
        message[getTypeKey(type)] === associationId &&
        message.author === currentUserId && !message.bot_name && !message.is_deleted && !Boolean(message.subtype || !message.author) && message.type === 'text'
    ));
    return result[0];
};
export const makeGetLastSelfMessage = () => createSelector(getLastSelfMessage, messages => messages);
